// Partner logos — all pre-processed to a uniform Elevate Blue (#2563EB) with
// transparent background. HD PNG sources rendered as plain <img> for crispness
// at any DPI, zero filter overhead.

const cls = "w-auto object-contain [image-rendering:-webkit-optimize-contrast]";

export const HorizonNutritionLogo = () => (
  <img src="/logos/horizon.png" alt="Horizon Nutrition" loading="eager" decoding="async" className={`${cls} h-16 sm:h-16`} />
);

export const AsaLogo = () => (
  <img src="/logos/asa.png" alt="ASA" loading="eager" decoding="async" className={`${cls} h-12 sm:h-12`} />
);

export const ShredAcademyLogo = () => (
  <img src="/logos/shred.png" alt="Shred Academy" loading="eager" decoding="async" className={`${cls} h-12 sm:h-14`} />
);

export const LegacyLogo = () => (
  <img src="/logos/legacy.png" alt="Legacy Properties" loading="eager" decoding="async" className={`${cls} h-10 sm:h-10`} />
);

export const CUSTOM_LOGOS = [
  { key: "horizon", C: HorizonNutritionLogo },
  { key: "asa", C: AsaLogo },
  { key: "shred", C: ShredAcademyLogo },
  { key: "legacy", C: LegacyLogo },
];
